import { useFormik } from "formik";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { changePassword } from "../../services/userService";
import Button from "../Button/Button";
import styles from "./ProfileEdit.module.css";

function PasswordUpdateModal({ isVisible, handleModal, onBusyChange }) {
  const formik = useFormik({
    initialValues: { oldPassword: "", newPassword: "", confirmPassword: "" },
    validationSchema: Yup.object({
      oldPassword: Yup.string().min(6, "A senha deve ter pelo menos 6 caracteres").required("Informe sua senha atual"),
      newPassword: Yup.string().min(6, "A senha deve ter pelo menos 6 caracteres").required("Informe uma nova senha"),
      confirmPassword: Yup.string().oneOf([Yup.ref("newPassword")], "As senhas devem ser iguais").required("Confirme a nova senha"),
    }),
    onSubmit: async (values, { resetForm }) => {
      onBusyChange?.(true);
      try {
        const response = await changePassword(values);
        if (!response.success) { toast.error(response.message || "Não foi possível alterar a senha."); return; }
        toast.success("Senha alterada com sucesso!");
        resetForm();
        handleModal(false);
      } catch {
        toast.error("Não foi possível alterar a senha. Tente novamente.");
      } finally {
        onBusyChange?.(false);
      }
    },
  });
  if (!isVisible) return null;

  return <form className={styles.form} onSubmit={formik.handleSubmit}>
    <div className={styles.sectionIntro}><h3>Segurança da conta</h3><p>Use uma senha exclusiva com pelo menos 6 caracteres.</p></div>
    <div className={styles.passwordFields}>
      {[["oldPassword", "Senha atual", "current-password"], ["newPassword", "Nova senha", "new-password"], ["confirmPassword", "Confirmar nova senha", "new-password"]].map(([name, label, autoComplete]) => {
        const error = formik.touched[name] && formik.errors[name];
        return <label key={name} htmlFor={"profile-" + name}>{label}
          <input type="password" id={"profile-" + name} name={name} autoComplete={autoComplete} value={formik.values[name]} onChange={formik.handleChange} onBlur={formik.handleBlur} disabled={formik.isSubmitting} aria-invalid={Boolean(error)} aria-describedby={error ? name + "-error" : undefined} />
          {error && <span id={name + "-error"} className={styles.errorMessage}>{error}</span>}
        </label>;
      })}
    </div>
    <footer className={styles.actions}><Button type="button" variant="secondary" onClick={() => handleModal(false)} disabled={formik.isSubmitting}>Cancelar</Button><Button type="submit" disabled={formik.isSubmitting}>{formik.isSubmitting ? "Salvando..." : "Alterar senha"}</Button></footer>
  </form>;
}
export default PasswordUpdateModal;
